// Consent record: read, write and validate the visitor's privacy choices.
// Storage can be unavailable (private mode, blocked site data), so every
// access is guarded and the site simply treats the visitor as undecided.
import { CONSENT_STORAGE_KEY, CONSENT_VERSION, CONSENT_MAX_AGE_DAYS, OPTIONAL_CATEGORIES, NOTICE_VERSION } from './privacyConfig';

const DAY = 24 * 60 * 60 * 1000;

export const emptyChoices = () => OPTIONAL_CATEGORIES.reduce((acc, k) => ({ ...acc, [k]: false }), {});

export const isValidRecord = (rec, now = Date.now()) => Boolean(
  rec
  && rec.version === CONSENT_VERSION
  && typeof rec.timestamp === 'string'
  && now - Date.parse(rec.timestamp) < CONSENT_MAX_AGE_DAYS * DAY
  && rec.categories && typeof rec.categories === 'object'
);

export const readConsent = () => {
  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    const rec = raw ? JSON.parse(raw) : null;
    return isValidRecord(rec) ? rec : null;
  } catch (e) {
    return null;
  }
};

export const buildRecord = (categories, method) => ({
  version: CONSENT_VERSION,
  noticeVersion: NOTICE_VERSION,
  timestamp: new Date().toISOString(),
  method, // 'accept-all' | 'reject-all' | 'custom' | 'inline:<category>'
  categories: { ...emptyChoices(), ...categories, necessary: true },
});

export const writeConsent = (record) => {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record));
  } catch (e) {
    // Storage blocked: the choice still applies for this page view.
  }
  return record;
};
